// import * as R from 'ramda';
import {
  takeLatest,
  select,
  // spawn,
  put,
  debounce,
} from 'redux-saga/effects';
import {
  generativeAi as genAiApis,
} from '../../../../api.js';
import { apiSaga } from '../../../../root-sagas.js';


function* getLLMParserInJson({ type, payload }) {
  const { toolId, partnerId } = yield select(state => state.generativeAi.partnerSettings.metadata);
  yield apiSaga(type, genAiApis.getLLMParser, [{
    toolId,
    partnerId,
    promptStrategy: payload ? payload.promptStrategy : '',
  }]);
  // After getting parsers, fetch rules
  yield put({ type: 'genAI_extractionSettings_getRules' });
}
function* getRules() {
  const { toolId } = yield select(state => state.generativeAi.partnerSettings.metadata);
  yield apiSaga('genAI_extractionSettings_getRules', genAiApis.getLLMRules, [{ toolId }]);
}

function* _saveParsersAndRulesForPartner({ partnerId }) {
  const { parsersInEdit, promptStrategy } = yield select(state => state.generativeAi.partnerSettings.extractionSettings);
  const { toolId } = yield select(state => state.generativeAi.partnerSettings.metadata);
  yield apiSaga('genAI_extractionSettings_saveParsers', genAiApis.saveLLMParser, [{
    toolId,
    partnerId,
    parsersInEdit,
    promptStrategy,
  }]);
}

function* doSaveParsersAndRules() {
  const { partnerId } = yield select(state => state.generativeAi.partnerSettings.metadata);
  yield _saveParsersAndRulesForPartner({ partnerId });
  yield put({ type: 'genAI_extractionSettings_getLLMParserInJson' })
  yield put({ type: 'genAI_extractionSettings_getRules' });
}

function* doCopyToPartner({ payload }) {
  const copyToPartnerId = payload.partnerId;
  yield _saveParsersAndRulesForPartner({ partnerId: copyToPartnerId });
  yield put({ type: 'genAI_extractionSettings_copyToPartner_SUCCESS' })
  debounce(4000, 'genAI_extractionSettings_updateProps', { text: '', severity: '' });
}

function* loadLLMParserForNewStrategy({ payload }) {
  const { toolId, partnerId } = yield select(state => state.generativeAi.partnerSettings.metadata);
  yield apiSaga('genAI_extractionSettings_loadLLMParserForNewStrategy', genAiApis.getLLMParser, [{
    toolId,
    partnerId,
    promptStrategy: payload.newStrategy || '',
  }]);
}

// eslint-disable-next-line
export default [
  takeLatest('genAI_extractionSettings_getLLMParserInJson', getLLMParserInJson),
  takeLatest('genAI_extractionSettings_getRules', getRules),
  takeLatest('genAI_extractionSettings_saveParsersAndRule', doSaveParsersAndRules),
  takeLatest('genAI_extractionSettings_copyToPartner', doCopyToPartner),
  takeLatest('genAI_extractionSettings_updatePromptStrategy', loadLLMParserForNewStrategy),
];